import { TrashIcon } from '@heroicons/react/24/outline'

interface ButtonGroupProps {
  /**
   * Title of Input
   */
  title?: Array<string> | Record<string, string>
  /**
   * Value of Input
   */
  value?: string
  /**
   * Custom class name
   */
  className?: string
  sort?: boolean
  hasRemove?: boolean
  onChange?: (checked: any) => void
  onRemove?: (value: any) => void
}

/**
 * Primary UI component for user interaction
 */
export const ButtonGroup = ({
  title = [],
  value = '',
  className = '',
  onChange = () => {},
  onRemove = () => {},
  sort = false,
  hasRemove = false,
  ...props
}: ButtonGroupProps) => {
  const isArray = Array.isArray(title)
  let keyArr: string[] = isArray ? (title as string[]) : Object.keys(title)
  if (sort) keyArr = [...keyArr].sort()

  // Modern segmented control: soft track with a raised active "chip".
  const base =
    'relative rounded-lg px-4 py-1.5 text-sm font-medium cursor-pointer select-none transition-all duration-150'
  const activeCls = 'bg-white text-shade-blue shadow-sm ring-1 ring-black/5'
  const inactiveCls = 'text-slate-600 hover:text-slate-900 hover:bg-white/70'

  return (
    <div className="inline-flex flex-wrap items-center gap-1 rounded-xl bg-slate-100 p-1" {...props}>
      {keyArr.map((key, index) => {
        const isActive = value == key
        const label = isArray ? key : (title as Record<string, string>)[key]
        const classes = [base, isActive ? activeCls : inactiveCls, className].join(' ')
        return (
          <a aria-current={isActive ? 'page' : undefined} className={classes} onClick={() => onChange(key)} key={`${key}-${index}`}>
            <div className="flex justify-center items-center gap-2">
              {hasRemove && (
                <TrashIcon
                  className="h-3.5 w-3.5 hover:text-red-500 hover:cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    onRemove(key)
                  }}
                />
              )}
              <span>{label}</span>
            </div>
          </a>
        )
      })}
    </div>
  )
}
